export const CHANGE_FONT = Symbol('changeFont');
export const LOAD_FONT_REQUEST = Symbol('loadFontRequest');
export const LOAD_FONT_SUCCESS = Symbol('loadFontSuccess');
export const LOAD_FONT_FAILURE = Symbol('loadFontFailure');
